var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 85,
    viewBox: "0 0 84 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_473_9819)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 41.9732,
    cy: 42.2945,
    r: 30.9331,
    fill: "white",
    fillOpacity: 0.3,
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.868 34.7913C38.7221 34.5361 41.5942 34.5584 44.4439 34.8578L45.1811 34.9353C46.5882 35.0831 47.7207 36.1504 47.9562 37.5395L51.9331 35.4266C52.2026 35.2834 52.5259 35.2849 52.7941 35.4305C53.0623 35.5762 53.2396 35.8466 53.2663 36.1506L53.2965 36.4949C53.6348 40.3545 53.6348 44.2362 53.2965 48.0958L53.2663 48.4401C53.2396 48.7441 53.0623 49.0145 52.7941 49.1602C52.5259 49.3058 52.2026 49.3073 51.9331 49.1641L47.9562 47.0513C47.7207 48.4403 46.5882 49.5076 45.1811 49.6555L44.4439 49.7329C41.5942 50.0324 38.7221 50.0546 35.868 49.7994L33.9492 49.6279C32.5033 49.4986 31.3351 48.394 31.1251 46.9577C30.6731 43.8659 30.6731 40.7248 31.1251 37.633C31.3351 36.1967 32.5033 35.0921 33.9492 34.9629L35.868 34.7913ZM48.1806 45.1662C48.278 45.1815 48.3744 45.213 48.4663 45.2618L51.5657 46.9085C51.7856 43.837 51.7856 40.7537 51.5657 37.6822L48.4663 39.3289C48.3744 39.3777 48.278 39.4092 48.1806 39.4245C48.3506 41.3346 48.3506 43.2561 48.1806 45.1662Z",
    fill: "#D8D8D8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_473_9819",
    x: 0.122465,
    y: 0.443754,
    width: 83.7014,
    height: 83.7023,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.45879
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_473_9819"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_473_9819",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoOn);
export default __webpack_public_path__ + "static/media/VideoOn.0295874c2483bfcc3143091fec82ff79.svg";
export { ForwardRef as ReactComponent };